<div class="card mt-3 article-list">
  <div class="card-body">
    <div class="d-flex flex-row">
      <div role="button"
        class="card w-25 m-2 border-0" routerLink="/article/{{article.id}}/{{encodeURIComponent(article.title.slice(0,55))}}"
        *ngFor="let article of articles">
        <div style="height:75px!important">
          <img
            [appImagePlaceholder]="getArticleImage(article)"
            class="card-img-top article-img"
            alt="article image" />
        </div>

        <div class="card-body">
          <h5 class="card-title line-clamp-1 pb-1">
            {{article.title}}
          </h5>
          <small class="text-muted line-clamp-3">{{article.description | htmlToText}}</small>
        </div>
      </div>
    </div>
  </div>
</div>
